/**
 * BT-046 — Jeu minimal de données initiales Phase 1.
 * Données réelles limitées aux noms explicitement fournis ; le reste « à confirmer ».
 */

export const SEED_BT_ID = "BT-GSD-KARATE-SEED-DONNEES-INITIALES-MINIMALES-046";

export const SEED_ADMIN_INSTRUCTOR_ID = "inst-gilles-lavigne";
export const SEED_STUDENT_MARCEL_ID = "seed-etud-marcel-charette";
export const SEED_STUDENT_NATALIE_ID = "seed-etud-natalie-lavigne";
export const SEED_STUDENT_DEMO_CHILD_ID = "seed-etud-demo-enfant";

export const SEED_RESPONSIBLE_COUNT = 10;
export const SEED_RESPONSIBLE_ID_PREFIX = "seed-responsable-";
export const SEED_DOJO_COUNT = 10;

export const SEED_CONFIRM_FR = "À confirmer";

const DOJO_ID_PREFIX = "demo-dojo-";

/** @param {number} index 1-based */
export function seedResponsibleId(index) {
  return `${SEED_RESPONSIBLE_ID_PREFIX}${String(index).padStart(2, "0")}`;
}

/** @param {number} index 1-based */
export function seedDojoId(index) {
  return `${DOJO_ID_PREFIX}${String(index).padStart(2, "0")}`;
}

/** @returns {import('./types.js').Dojo[]} */
export function buildSeedDojos(count = SEED_DOJO_COUNT) {
  return Array.from({ length: count }, (_, i) => {
    const n = i + 1;
    return {
      id: seedDojoId(n),
      nom: `[DÉMO] Emplacement dojo ${n} — à confirmer`,
      ville: "Ville à confirmer",
      adresse: "Adresse à confirmer",
      telephone: "",
      courriel: "",
      sensei_id: n === 1 ? "demo-sensei-placeholder" : null,
      sempai_id: seedResponsibleId(n),
      statut: "a_confirmer",
      demo: true,
    };
  });
}

/** @returns {import('./types.js').Instructeur[]} */
export function buildSeedResponsibles(count = SEED_RESPONSIBLE_COUNT) {
  return Array.from({ length: count }, (_, i) => {
    const n = i + 1;
    const titre = n % 2 === 0 ? "Sempai / assistant" : "Responsable / assistant";
    return {
      id: seedResponsibleId(n),
      nom: `Responsable ${n} — à confirmer`,
      titre,
      dojo_id: seedDojoId(n),
      courriel: "",
      telephone: "",
      statut: "a_confirmer",
      demo: true,
    };
  });
}

/** Leadership reçu — titres document BlackDragon2026 ; dojo_id null = non assigné */
/** @type {import('./types.js').Instructeur[]} */
export const BLACK_DRAGON_LEADERSHIP_INSTRUCTORS = [
  {
    id: "inst-gilles-lavigne",
    nom: "Gilles Lavigne",
    titre: "Hanshi",
    organisation: "Shotokan",
    dojo_id: null,
    courriel: "shotokanaamc@gmail.com",
    telephone: "",
    statut: "actif",
    demo: false,
  },
  {
    id: "inst-marcel-gauthier",
    nom: "Marcel Gauthier",
    titre: "Hanshi",
    dojo_id: null,
    courriel: "gauthier.karate@gmail.com",
    telephone: "",
    statut: "actif",
    demo: false,
  },
  {
    id: "inst-stephane-lachapelle",
    nom: "Stéphane Lachapelle",
    titre: "Kyoshi",
    dojo_id: null,
    courriel: "stephanelachapelle@hotmail.com",
    telephone: "",
    statut: "actif",
    demo: false,
  },
  {
    id: "inst-jacki-st-arnaud",
    nom: "Jaki St-Arnaud",
    titre: "Shihan",
    dojo_id: null,
    courriel: "jaki-st-arnaud@hotmail.com",
    telephone: "",
    statut: "actif",
    demo: false,
  },
  {
    id: "inst-kent-ouelette",
    nom: "Kent Ouelette",
    titre: "Renshi",
    dojo_id: null,
    courriel: "karatedolacorne@hotmail.com",
    telephone: "",
    statut: "actif",
    demo: false,
  },
  {
    id: "inst-dan-lepine",
    nom: "Dan Lépine",
    titre: "Renshi",
    dojo_id: null,
    courriel: "danlepine70@gmail.com",
    telephone: "",
    statut: "actif",
    demo: false,
  },
  {
    id: "inst-denis-gauthier",
    nom: "Denis Gauthier",
    titre: "Shihan",
    dojo_id: null,
    courriel: "senseidenis@hotmail.com",
    telephone: "",
    statut: "actif",
    demo: false,
  },
  {
    id: "inst-pierre-boisvenue",
    nom: "Pierre Boisvenue",
    titre: "Shihan",
    dojo_id: null,
    courriel: "pierreboisvenue@hotmail.com",
    telephone: "",
    statut: "actif",
    demo: false,
  },
  {
    id: "inst-gaston-berube",
    nom: "Gaston Bérubé",
    titre: "Shihan",
    dojo_id: null,
    courriel: "senseigberube@bell.net",
    telephone: "",
    statut: "actif",
    demo: false,
  },
];

/** @returns {import('./types.js').Etudiant[]} */
export function buildSeedStudents() {
  return [
    {
      id: SEED_STUDENT_MARCEL_ID,
      prenom: "Marcel",
      nom: "Charette",
      dojo_id: seedDojoId(1),
      groupe: SEED_CONFIRM_FR,
      ceinture: SEED_CONFIRM_FR,
      class_id: "demo-class-02",
      statut: "actif",
      demo: false,
    },
    {
      id: SEED_STUDENT_NATALIE_ID,
      prenom: "Natalie",
      nom: "Lavigne",
      dojo_id: seedDojoId(1),
      groupe: SEED_CONFIRM_FR,
      ceinture: SEED_CONFIRM_FR,
      statut: "actif",
      demo: false,
    },
    {
      id: SEED_STUDENT_DEMO_CHILD_ID,
      prenom: "[DÉMO]",
      nom: "Enfant démo — espace Parent",
      dojo_id: seedDojoId(1),
      groupe: SEED_CONFIRM_FR,
      ceinture: SEED_CONFIRM_FR,
      class_id: "demo-class-01",
      statut: "a_confirmer",
      demo: true,
    },
  ];
}

/** @param {import('./types.js').Instructeur | null | undefined} instructeur */
export function isSeedResponsible(instructeur) {
  return Boolean(instructeur?.id?.startsWith(SEED_RESPONSIBLE_ID_PREFIX));
}

/** @param {import('./types.js').Instructeur[]} instructeurs */
export function filterSeedResponsibles(instructeurs) {
  return (instructeurs || []).filter(isSeedResponsible);
}

/** @param {import('./types.js').Instructeur[]} instructeurs */
export function countSeedResponsibles(instructeurs) {
  return filterSeedResponsibles(instructeurs).length;
}
